module.exports = __webpack_public_path__ + "img/136.3.c9620a47.png";